/* ==========================================================================
   MONA PRODUCT — variants, gallery, AJAX cart, option drawer, lightbox
   Canonical state = hidden [data-mona-option] radios.
   Visible UI = summary cards (colour/config, open drawer) + size cards (proxy).
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-mona-pdp]');
  if (!root) return;
  var body = document.body;

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-mona-variants]').textContent); } catch (e) {}

  /* ---- "Sofa Set" synthetic configuration ---- */
  var setData = null;
  try {
    var sdEl = root.querySelector('[data-mona-set-data]');
    if (sdEl) { setData = JSON.parse(sdEl.textContent); setData.rows = setData.rows.filter(Boolean); }
  } catch (e) { setData = null; }
  var setActive = false;
  function calcSet(colour) {
    if (!setData) return null;
    var pick = {};
    setData.rows.forEach(function (r) { if ((r.col || '') === (colour || '')) pick[r.cfg] = r; });
    if (!pick.Sofa || !pick.Armchair) return null;
    var items, total;
    if (setData.hasLove && pick.Loveseat) {
      items = [{ id: pick.Sofa.id, quantity: 1 }, { id: pick.Loveseat.id, quantity: 1 }, { id: pick.Armchair.id, quantity: 1 }];
      total = pick.Sofa.price + pick.Loveseat.price + pick.Armchair.price;
    } else {
      items = [{ id: pick.Sofa.id, quantity: 2 }, { id: pick.Armchair.id, quantity: 1 }];
      total = pick.Sofa.price * 2 + pick.Armchair.price;
    }
    return { items: items, total: total };
  }
  function findSetImage(colour) {
    var want = (colour || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean);
    var cands = [];
    root.querySelectorAll('.mona-pdp__slide img').forEach(function (img) {
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      if (alt.indexOf('set') === -1) return;
      if (want.length && !want.every(function (t) { return alt.indexOf(t) !== -1; })) return;
      // rank: exact recipe > full suite > any set shot
      var score = 1;
      if (setData && setData.hasLove && alt.indexOf('sofa loveseat armchair') !== -1) score = 3;
      if (setData && !setData.hasLove && alt.indexOf('sofa sofa armchair') !== -1) score = 3;
      if (alt.indexOf('full suite') !== -1) score = 2;
      cands.push({ src: img.currentSrc || img.src, score: score });
    });
    cands.sort(function (a, b) { return b.score - a.score; });
    return cands.length ? cands[0].src : null;
  }
  function currentColour() {
    if (!setData || !setData.colPos) return '';
    return getSelectedValues()[setData.colPos - 1] || '';
  }
  /* ---- financing estimate for synthetic sets ----
     "Sofa Set" has no real variant, so shopify-payment-terms can never quote
     it. When a set is active we hide the component and show an estimate
     computed from the financing plan tiers Shopify embeds in shopify-meta;
     a real variant selection restores the stock component untouched. */
  function computeTermsEstimate(totalCents, plans) {
    if (!plans || !plans.length) return null;
    function cents(s) { var n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    var tier = null;
    plans.forEach(function (p) {
      var lo = cents(p.min_price), hi = cents(p.max_price);
      if (lo != null && hi != null && totalCents >= lo && totalCents <= hi) tier = p;
    });
    if (!tier || !tier.terms) return null;
    var interest = tier.terms.filter(function (t) { return t.loan_type === 'interest'; });
    if (interest.length) {
      var best = null;
      interest.forEach(function (t) {
        var r = (t.apr / 100) / 12, n = t.installments_count;
        var m = r > 0 ? totalCents * r / (1 - Math.pow(1 + r, -n)) : totalCents / n;
        if (best === null || m < best) best = m;
      });
      return 'From ' + money(Math.round(best)) + '/mo with Shop Pay';
    }
    var sp = tier.terms.filter(function (t) { return t.loan_type === 'split_pay'; });
    if (sp.length) {
      var n2 = Math.max.apply(null, sp.map(function (t) { return t.installments_count; }));
      return n2 + ' interest-free payments of ' + money(Math.round(totalCents / n2)) + ' with Shop Pay';
    }
    return null;
  }
  function showSetTermsEstimate(totalCents) {
    document.querySelectorAll('shopify-payment-terms').forEach(function (pt) {
      var meta = null;
      try { meta = JSON.parse(pt.getAttribute('shopify-meta')); } catch (e) {}
      var est = meta ? computeTermsEstimate(totalCents, meta.financing_plans) : null;
      var note = pt.parentNode.querySelector('[data-mona-set-terms]');
      if (!est) { pt.style.display = ''; if (note) note.remove(); return; }
      pt.style.display = 'none';
      if (!note) {
        note = document.createElement('div');
        note.setAttribute('data-mona-set-terms', '');
        note.className = 'mona-set-terms';
        pt.parentNode.insertBefore(note, pt);
      }
      note.textContent = est;
    });
  }
  function clearSetTermsEstimate() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (pt) {
      pt.style.display = '';
      var note = pt.parentNode.querySelector('[data-mona-set-terms]');
      if (note) note.remove();
    });
  }

  function applySetOverlay() {
    if (!setActive || !setData) return;
    var c = calcSet(currentColour());
    if (!c) return;
    if (priceEl) priceEl.textContent = money(c.total);
    if (atcPriceEl) atcPriceEl.textContent = money(c.total);
    var dp = root.querySelector('[data-mona-vardrawer-price]');
    if (dp) dp.textContent = money(c.total);
    showSetTermsEstimate(c.total);
    // summary card shows the set
    var btn = root.querySelector('[data-mona-open-drawer][data-option-position="' + setData.cfgPos + '"]');
    if (btn) {
      var valEl = btn.querySelector('[data-mona-summary-value]');
      if (valEl) valEl.textContent = 'Sofa Set';
      var setOpt = root.querySelector('[data-mona-set-opt]');
      var thumbEl = btn.querySelector('[data-mona-summary-thumb]');
      if (setOpt && thumbEl) {
        var t = setOpt.querySelector('.mona-vardrawer__opt-thumb');
        if (t) { thumbEl.style.backgroundImage = ''; thumbEl.style.backgroundColor = ''; thumbEl.innerHTML = t.innerHTML; }
      }
    }
  }

  var form = root.querySelector('#MonaProductForm');
  var idInput = root.querySelector('[data-mona-variant-id]');
  var priceEl = root.querySelector('[data-mona-price]');
  var atcPriceEl = root.querySelector('[data-mona-atc-price]');
  var availEl = root.querySelector('[data-mona-availability]');
  var atcBtn = root.querySelector('[data-mona-atc]');
  var atcText = root.querySelector('[data-mona-atc-text]');

  var noCents = root.hasAttribute('data-mona-money-nocents');
  function money(cents) {
    if (noCents) return '$' + Math.round(cents / 100).toLocaleString();
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'CAD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function getSelectedValues() {
    var vals = [];
    root.querySelectorAll('[data-mona-option]:checked').forEach(function (input) {
      vals[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
    });
    return vals;
  }
  function findVariant(values) {
    return variants.find(function (v) { return v.options.every(function (opt, i) { return opt === values[i]; }); });
  }
  function setCanonical(position, value) {
    var input = root.querySelector('[data-mona-option][data-option-position="' + position + '"][value="' + CSS.escape(value) + '"]');
    if (input) input.checked = true;
  }

  /* ---- refresh visible selector UI from canonical state ---- */
  function refreshSelectors() {
    var values = getSelectedValues();
    // summary cards (colour / configuration)
    root.querySelectorAll('[data-mona-open-drawer]').forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10);
      var val = values[pos - 1];
      var valEl = btn.querySelector('[data-mona-summary-value]');
      if (valEl && val) valEl.textContent = val;
      // copy thumbnail from matching drawer option
      var drawerOpt = root.querySelector('[data-mona-varopt][data-option-position="' + pos + '"][data-value="' + CSS.escape(val || '') + '"]');
      var thumbEl = btn.querySelector('[data-mona-summary-thumb]');
      if (drawerOpt && thumbEl) {
        var dThumb = drawerOpt.querySelector('.mona-vardrawer__opt-thumb');
        if (dThumb) {
          if (dThumb.style.backgroundImage && dThumb.style.backgroundImage !== 'none') {
            thumbEl.style.backgroundImage = dThumb.style.backgroundImage;
            thumbEl.style.backgroundColor = ''; thumbEl.innerHTML = '';
          } else if (dThumb.style.backgroundColor) {
            thumbEl.style.backgroundImage = '';
            thumbEl.style.backgroundColor = dThumb.style.backgroundColor; thumbEl.innerHTML = '';
          } else {
            thumbEl.style.backgroundImage = ''; thumbEl.innerHTML = dThumb.innerHTML;
          }
        }
      }
    });
    // size proxy cards
    root.querySelectorAll('[data-mona-proxy]').forEach(function (proxy) {
      var pos = parseInt(proxy.getAttribute('data-option-position'), 10);
      var on = proxy.value === values[pos - 1];
      proxy.checked = on;
      var cfgCard = proxy.closest('[data-mona-cfgcard]');
      if (cfgCard && setActive && setData && pos === setData.cfgPos) { on = false; proxy.checked = false; }
      var card = proxy.closest('.mona-pdp__sizecard') || proxy.closest('.mona-pdp__mountcard') || cfgCard;
      if (card) card.classList.toggle('is-selected', on);
    });
    // sofa configuration buttons: availability for the current colour + set state
    var cfgGroup = root.querySelector('.mona-pdp__selgroup--cfg');
    if (cfgGroup) {
      var cfgPos = 0;
      var anyProxy = cfgGroup.querySelector('[data-mona-proxy]');
      if (anyProxy) cfgPos = parseInt(anyProxy.getAttribute('data-option-position'), 10);
      cfgGroup.querySelectorAll('[data-mona-cfgcard]').forEach(function (c) {
        var want = values.slice(); want[cfgPos - 1] = c.getAttribute('data-value');
        var v = findVariant(want);
        c.classList.toggle('is-unavailable', !v || !v.available);
      });
      var setBtn = cfgGroup.querySelector('[data-mona-cfg-set]');
      if (setBtn) {
        setBtn.classList.toggle('is-selected', setActive);
        setBtn.setAttribute('aria-checked', setActive ? 'true' : 'false');
        setBtn.hidden = !calcSet(currentColour());
      }
      var note = cfgGroup.querySelector('[data-mona-cfg-note]');
      if (note) note.hidden = !setActive;
      var cl = cfgGroup.querySelector('[data-mona-cfg-label]');
      if (cl) cl.textContent = setActive ? 'Sofa Set' : (values[cfgPos - 1] || '');
    }
    // mounting picture cards: keep each thumbnail on the current size/colour
    root.querySelectorAll('[data-mona-mountcard]').forEach(function (card) {
      var proxy = card.querySelector('[data-mona-proxy]');
      if (!proxy) return;
      var pos = parseInt(proxy.getAttribute('data-option-position'), 10);
      var want = values.slice();
      want[pos - 1] = card.getAttribute('data-value');
      var v = findVariant(want);
      var img = card.querySelector('[data-mona-mount-img]');
      if (v && v.featured_image && v.featured_image.src && img) {
        var src = v.featured_image.src.split('?')[0] + '?width=260';
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
      var lbl = root.querySelector('[data-mona-mount-label]');
      if (lbl && values[pos - 1]) lbl.textContent = values[pos - 1];
    });
    // drawer option selected states
    root.querySelectorAll('[data-mona-varopt]').forEach(function (opt) {
      var pos = parseInt(opt.getAttribute('data-option-position'), 10);
      opt.classList.toggle('is-selected', opt.getAttribute('data-value') === values[pos - 1]);
    });
  }

  function updateVariant() {
    var values = getSelectedValues();
    var variant = findVariant(values);
    refreshSelectors();
    if (!variant) {
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Unavailable';
      return;
    }
    if (idInput) idInput.value = variant.id;
    /* keep the Shop Pay Installments estimate ("From $x/mo") on the selected
       variant — the component re-renders when its variant-id attribute changes.
       A synthetic Sofa Set has no real variant: applySetOverlay swaps in a
       computed estimate instead, so skip the sync there. */
    if (!setActive) {
      clearSetTermsEstimate();
      document.querySelectorAll('shopify-payment-terms').forEach(function (pt) {
        pt.setAttribute('variant-id', String(variant.id));
      });
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML = '<span class="mona-price__compare">' + money(variant.compare_at_price) + '</span> <span class="mona-price__sale">' + money(variant.price) + '</span>';
      } else { priceEl.textContent = money(variant.price); }
    }
    if (atcPriceEl) atcPriceEl.textContent = money(variant.price);

    if (variant.available) {
      if (atcBtn) atcBtn.disabled = false;
      if (atcText) atcText.textContent = 'Add to Cart';
      if (availEl) { availEl.textContent = 'In stock'; availEl.classList.remove('is-out'); }
    } else {
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Sold out';
      if (availEl) { availEl.textContent = 'Sold out'; availEl.classList.add('is-out'); }
    }
    var dPrice = root.querySelector('[data-mona-vardrawer-price]');
    if (dPrice) dPrice.textContent = money(variant.price);

    filterGalleryByVariant(variant, values);
    applySetOverlay();
    document.dispatchEvent(new CustomEvent('mona:variant-change'));
  }

  root.querySelectorAll('[data-mona-option]').forEach(function (i) { i.addEventListener('change', updateVariant); });

  /* size proxy radios -> canonical */
  root.querySelectorAll('[data-mona-proxy]').forEach(function (proxy) {
    proxy.addEventListener('change', function () {
      if (proxy.closest('[data-mona-cfgcard]')) setActive = false;
      setCanonical(proxy.getAttribute('data-option-position'), proxy.value);
      updateVariant();
    });
  });

  /* Sofa Set button (sofas / sofa beds) */
  var cfgSetBtn = root.querySelector('[data-mona-cfg-set]');
  if (cfgSetBtn) cfgSetBtn.addEventListener('click', function () {
    if (!setData) return;
    setActive = true;
    updateVariant();
    var simg = findSetImage(currentColour());
    if (simg) {
      var hit = slides.find(function (sl) { var im = sl.querySelector('img'); return im && (im.currentSrc || im.src) === simg; });
      if (hit && visibleIds.indexOf(hit.dataset.mediaId) !== -1) showMedia(hit.dataset.mediaId);
    }
  });

  /* ---- Gallery carousel (filtered by variant) ---- */
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mona-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mona-thumb]'));
  var variantMediaMap = {};
  try { variantMediaMap = JSON.parse(root.querySelector('[data-mona-variant-media]').textContent); } catch (e) {}
  var hasVariantMedia = slides.some(function (s) { return s.dataset.variantMedia === '1'; });
  var visibleIds = slides.map(function (s) { return s.dataset.mediaId; });
  var currentId = slides.length ? slides[0].dataset.mediaId : null;

  function showMedia(id) {
    if (!id) return;
    currentId = id;
    slides.forEach(function (s) {
      var on = s.dataset.mediaId === id;
      s.classList.toggle('is-current', on);
      var v = s.querySelector('video');
      if (v) { if (on) { v.play && v.play().catch(function(){}); } else { v.pause && v.pause(); } }
    });
    thumbs.forEach(function (t) { t.classList.toggle('is-current', t.dataset.mediaId === id); });
  }
  function syncThumbs() {
    thumbs.forEach(function (t) { t.hidden = visibleIds.indexOf(t.dataset.mediaId) === -1; });
  }
  function step(dir) {
    if (!visibleIds.length) return;
    var i = visibleIds.indexOf(currentId);
    showMedia(visibleIds[(i + dir + visibleIds.length) % visibleIds.length]);
  }
  function filterGalleryByVariant(variant) {
    if (hasVariantMedia && variant) {
      var vm = String(variantMediaMap[variant.id] || '');
      visibleIds = slides.filter(function (s) {
        return s.dataset.variantMedia === '1' ? s.dataset.mediaId === vm : true;
      }).map(function (s) { return s.dataset.mediaId; });
      syncThumbs();
      if (vm && visibleIds.indexOf(vm) !== -1) { showMedia(vm); }
      else if (visibleIds.indexOf(currentId) === -1) { showMedia(visibleIds[0]); }
    } else {
      visibleIds = slides.map(function (s) { return s.dataset.mediaId; });
      syncThumbs();
    }
  }
  var galPrev = root.querySelector('[data-mona-gal-prev]');
  var galNext = root.querySelector('[data-mona-gal-next]');
  if (galPrev) galPrev.addEventListener('click', function () { step(-1); });
  if (galNext) galNext.addEventListener('click', function () { step(1); });
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
  });

  /* initial state: reflect the pre-selected variant (incl. gallery filter) */
  if (variants.length) { try { updateVariant(); } catch (e) {} }

  /* ---- Video unmute ---- */
  root.querySelectorAll('[data-mona-video-unmute]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-mona-video-wrap]');
      var video = wrap && wrap.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.muted) video.play();
    });
  });

  /* ---- AJAX add to cart ---- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn.disabled) return;
      atcBtn.classList.add('is-loading');
      var origText = atcText ? atcText.textContent : '';
      if (atcText) atcText.textContent = 'Adding…';
      var addReq;
      var setCombo = setActive ? calcSet(currentColour()) : null;
      if (setCombo) {
        addReq = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/javascript', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: setCombo.items })
        });
      } else {
        addReq = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/javascript' }, body: new FormData(form)
        });
      }
      addReq.then(function (r) { return r.json(); })
        .then(function () {
          if (atcText) atcText.textContent = 'Added ✓';
          updateCartUI();
          setTimeout(function () { if (atcText) atcText.textContent = origText; atcBtn.classList.remove('is-loading'); }, 1400);
        })
        .catch(function () { if (atcText) atcText.textContent = origText; atcBtn.classList.remove('is-loading'); form.submit(); });
    });
  }
  function updateCartUI() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.querySelector('[data-mona-cart-count]');
        if (count) { count.textContent = cart.item_count; count.classList.toggle('is-empty', cart.item_count === 0); }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(); }
      });
  }

  /* ---- Option drawer (colour / configuration / size) — all viewports ---- */
  var vdrawer = root.querySelector('[data-mona-vardrawer]');
  var voverlay = root.querySelector('[data-mona-vardrawer-overlay]');
  if (vdrawer) {
    var pending = {};
    var previewImg = vdrawer.querySelector('[data-mona-vardrawer-img]');
    function setPreview(src) { if (previewImg && src) { previewImg.src = src; previewImg.removeAttribute('srcset'); } }
    function openVarDrawer(position) {
      root.querySelectorAll('[data-mona-option]:checked').forEach(function (i) { pending[i.getAttribute('data-option-position')] = i.value; });
      syncDrawer();
      switchTab(position || '1');
      // preview = the set shot when a set is active, else first visible image
      var openImg = setActive ? findSetImage(currentColour()) : null;
      if (!openImg) {
        var firstVisible = slides.find(function (s) { return s.style.display !== 'none' && s.querySelector('img'); });
        if (firstVisible) { var fi = firstVisible.querySelector('img'); if (fi) openImg = fi.src; }
      }
      if (openImg) setPreview(openImg);
      vdrawer.classList.add('is-open'); vdrawer.setAttribute('aria-hidden', 'false');
      if (voverlay) voverlay.classList.add('is-open');
      body.classList.add('mona-no-scroll');
    }
    function closeVarDrawer() {
      vdrawer.classList.remove('is-open'); vdrawer.setAttribute('aria-hidden', 'true');
      if (voverlay) voverlay.classList.remove('is-open');
      body.classList.remove('mona-no-scroll');
    }
    function switchTab(position) {
      vdrawer.querySelectorAll('[data-mona-vartab]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-mona-vartab') === position); });
      vdrawer.querySelectorAll('[data-mona-varpane]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mona-varpane') === position); });
    }
    function syncDrawer() {
      vdrawer.querySelectorAll('[data-mona-varopt]').forEach(function (opt) {
        opt.classList.toggle('is-selected', pending[opt.getAttribute('data-option-position')] === opt.getAttribute('data-value'));
      });
    }
    root.querySelectorAll('[data-mona-open-drawer]').forEach(function (btn) {
      btn.addEventListener('click', function () { openVarDrawer(btn.getAttribute('data-option-position')); });
    });
    vdrawer.querySelectorAll('[data-mona-vartab]').forEach(function (t) { t.addEventListener('click', function () { switchTab(t.getAttribute('data-mona-vartab')); }); });
    vdrawer.querySelectorAll('[data-mona-varopt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        pending[opt.getAttribute('data-option-position')] = opt.getAttribute('data-value');
        syncDrawer();
        if (opt.hasAttribute('data-mona-set-opt') && setData) {
          var scol = setData.colPos ? (pending[String(setData.colPos)] || currentColour()) : '';
          var simg = findSetImage(scol);
          if (simg) setPreview(simg);
        } else if (opt.getAttribute('data-full')) {
          setPreview(opt.getAttribute('data-full'));
        }
        // live price on the Select button for the pending combination
        var vals = getSelectedValues();
        Object.keys(pending).forEach(function (pos) { vals[pos - 1] = pending[pos]; });
        var dp = vdrawer.querySelector('[data-mona-vardrawer-price]');
        if (setData && pending[String(setData.cfgPos)] === 'Sofa Set') {
          var pcol = setData.colPos ? (pending[String(setData.colPos)] || currentColour()) : '';
          var pc = calcSet(pcol);
          if (pc && dp) dp.textContent = money(pc.total);
        } else {
          var pv = findVariant(vals);
          if (pv && dp) dp.textContent = money(pv.price);
        }
      });
    });
    var applyBtn = vdrawer.querySelector('[data-mona-vardrawer-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      setActive = !!(setData && pending[String(setData.cfgPos)] === 'Sofa Set');
      Object.keys(pending).forEach(function (pos) {
        if (setActive && setData && pos === String(setData.cfgPos)) return; // no real variant for the set
        setCanonical(pos, pending[pos]);
      });
      updateVariant(); closeVarDrawer();
    });
    var cBtn = vdrawer.querySelector('[data-mona-vardrawer-close]');
    if (cBtn) cBtn.addEventListener('click', closeVarDrawer);
    if (voverlay) voverlay.addEventListener('click', closeVarDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && vdrawer.classList.contains('is-open')) closeVarDrawer(); });
  }

  /* "Detailed Dimensions" link -> open the Dimensions accordion */
  root.querySelectorAll('[data-mona-open-dims]').forEach(function (link) {
    link.addEventListener('click', function () {
      var acc = root.querySelector('[data-mona-accordions] details');
      root.querySelectorAll('[data-mona-accordions] details').forEach(function (d) {
        if (d.querySelector('.mona-acc__head') && /dimension/i.test(d.querySelector('.mona-acc__head').textContent)) { d.open = true; acc = d; }
      });
      if (acc) acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---- From-customers carousel arrows ---- */
  var fyGroup = root.querySelector('[data-mona-fromyou-group]');
  if (fyGroup) {
    var fyScroller = fyGroup.querySelector('[data-mona-fromyou-scroller]');
    var fyPrev = fyGroup.querySelector('[data-mona-fy-prev]');
    var fyNext = fyGroup.querySelector('[data-mona-fy-next]');
    function fyAmount() { var f = fyScroller && fyScroller.querySelector(':scope > *'); return f ? f.offsetWidth + 24 : 320; }
    if (fyScroller && fyPrev) fyPrev.addEventListener('click', function () { fyScroller.scrollBy({ left: -fyAmount(), behavior: 'smooth' }); });
    if (fyScroller && fyNext) fyNext.addEventListener('click', function () { fyScroller.scrollBy({ left: fyAmount(), behavior: 'smooth' }); });
  }

  /* ---- From-customers Instagram-style lightbox ---- */
  var lb = root.querySelector('[data-mona-lightbox]');
  if (lb) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mona-fromyou-item]'));
    var lbImg = lb.querySelector('[data-mona-lb-img]'), lbCap = lb.querySelector('[data-mona-lb-caption]');
    var lbName = lb.querySelector('[data-mona-lb-name]'), lbLoc = lb.querySelector('[data-mona-lb-location]'), lbIg = lb.querySelector('[data-mona-lb-instagram]');
    var lbCapWrap = lb.querySelector('[data-mona-lb-capwrap]');
    var lbCard = lb.querySelector('.mona-lightbox__card');
    var cur = 0;
    var preloaded = {};

    // Warm the browser cache so stepping through photos swaps instantly
    // instead of waiting on a fresh 1200px download per click.
    function preload(i) {
      var el = items[(i + items.length) % items.length];
      if (!el) return;
      var url = el.getAttribute('data-full');
      if (!url || preloaded[url]) return;
      preloaded[url] = new Image();
      preloaded[url].src = url;
    }

    function render(i) {
      var el = items[i]; if (!el) return; cur = i;
      var name = el.getAttribute('data-name') || '', caption = el.getAttribute('data-caption') || '', loc = el.getAttribute('data-location') || '', ig = el.getAttribute('data-instagram') || '';
      lbImg.src = el.getAttribute('data-full'); lbImg.alt = name; lbImg.decoding = 'sync'; lbImg.fetchPriority = 'high';
      lbCap.textContent = caption;
      lbName.textContent = name;
      lbLoc.textContent = loc;
      if (ig) { lbIg.href = ig; lbIg.hidden = false; } else { lbIg.hidden = true; }
      // hide the caption panel entirely if there's nothing to show
      var empty = !name && !caption && !loc && !ig;
      if (lbCapWrap) lbCapWrap.classList.toggle('is-empty', empty);
      if (lbCard) lbCard.classList.toggle('is-nocap', empty);
      preload(i + 1); preload(i - 1);
    }
    function preloadAll() { items.forEach(function (el, n) { preload(n); }); }
    function openLb(i) { render(i); preloadAll(); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); body.classList.add('mona-no-scroll'); }
    // Prime the whole set once the gallery is hovered — by the time the
    // lightbox opens the images are already in cache.
    items.forEach(function (el, i) {
      el.addEventListener('mouseenter', function () { preload(i); preload(i + 1); }, { once: true });
    });
    function closeLb() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); body.classList.remove('mona-no-scroll'); }
    items.forEach(function (el, i) { el.addEventListener('click', function () { openLb(i); }); });
    lb.querySelector('[data-mona-lb-close]').addEventListener('click', closeLb);
    lb.querySelector('[data-mona-lb-next]').addEventListener('click', function () { render((cur + 1) % items.length); });
    lb.querySelector('[data-mona-lb-prev]').addEventListener('click', function () { render((cur - 1 + items.length) % items.length); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') render((cur + 1) % items.length);
      if (e.key === 'ArrowLeft') render((cur - 1 + items.length) % items.length);
    });
  }

  /* init */
  refreshSelectors();
})();
